import { Layout as DashboardLayout } from 'src/layouts/dashboard';
import { Layout as AuthLayout } from 'src/layouts/auth';
import { Loading } from 'src/components/loading';
import { showLog } from 'src/utils/debug-log';

const AppLayout = ({ areauthed, children }) => {
  showLog('***** App-Layout *****');
  return (
    <>
      <Loading />
      {areauthed ? (
        <DashboardLayout>{children}</DashboardLayout>
      ) : (
        <AuthLayout>{children}</AuthLayout>
      )}
    </>
  );
};

export default AppLayout;
